export class SetParentAction {
  public static readonly type = '[Project/Storage/List] SetParentAction';
}
